import { Component, Input, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { BarcodeScanner, CameraDirection, ScanOptions } from '@capacitor-community/barcode-scanner';
import { EnterConfirmIdComponent } from '../enter-confirm-id/enter-confirm-id.component';
import { UtilsService } from 'src/app/core/services/utils.service';
import { FarmDeviceDetailItem } from '../../models/farm-device.model';
import { IFarmSaveModel } from 'src/app/core/models/interfaces/farm-save-model';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from 'src/app/core/services/permission.service';
import { TranslateService } from '@ngx-translate/core';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { ToastService } from 'src/app/core/services/toast.service';
import { Subscription } from 'rxjs';
import { DetailService } from '../../services/detail.service';

@Component({
  selector: 'app-device-update',
  templateUrl: './device-update.component.html',
  styleUrls: ['./device-update.component.scss'],
})
export class DeviceUpdateComponent extends BaseModal implements OnInit {
  isFilizMode: boolean = true;
  isTorch: boolean = false;
  deviceID: string;
  direction: CameraDirection.FRONT | CameraDirection.BACK = CameraDirection.BACK
  show: boolean = true;
  farm: FarmDeviceDetailItem
  querySubs: Subscription;
  tempFarmAttrId: number;
  sensorType: string = "";
  constructor(private storageService: StorageService, private loadingService: LoadingService,
    private router: Router,
    private modalService: ModalService, private utilsService: UtilsService, private farmApi: FarmApiService,
    private activatedRoute: ActivatedRoute,
    private permissionService: PermissionService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private detailService: DetailService) {
    super();
    super._modalService = modalService;
  }

  ngOnInit() {
    super.ngOnInit();
    this.storageService.get(StorageKeys.FILIZ_MODE).then(res => {
      if (res.IsSuccess) {
        this.isFilizMode = res.Data;
      }
    });
  }

  ionViewDidEnter() {
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["farmId"]) {
        this.tempFarmAttrId = +e["farmId"];
      }
      if (e["sensorType"]) {
        this.sensorType = e["sensorType"];
      }
    });
    this.getDetail();
  }
  getDetail() {
    this.loadingService.showLoading();
    this.detailService.getDetail(this.sensorType, this.tempFarmAttrId).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.farm = res.Data;
      }
    });
  }

  startScan() {
    this.permissionService.requestCameraPermission("CAMERA").subscribe(permission => {
      if (permission) {
        this.show = false;
        document.body.style.setProperty('background-color', 'transparent');
        const result = BarcodeScanner.startScan().then(e => {
          this.show = true;
          document.body.style.removeProperty('background-color');
          if (e.hasContent) {
            // let data = JSON.parse(e.content);
            // if (data.DeviceId) {
            this.deviceID = e.content;
            this.enterManually(this.deviceID);
            // }
          }
        });
      }
      // else {
      //   this.toastService.PresentBasicToast({
      //     message: this.translateService.instant("general.permission-error-camera"),
      //     duration: 3500,
      //     type: Message_Type.WARNING
      //   });
      // }
    });
  }

  changeDirection() {
    // let options:ScanOptions = {
    //   cameraDirection
    // }
    this.direction = this.direction == CameraDirection.BACK ? CameraDirection.FRONT : CameraDirection.BACK;
    BarcodeScanner.stopScan().then(e => {
      BarcodeScanner.startScan({ cameraDirection: this.direction }).then(e => {
        if (e.hasContent) {
          let data = JSON.parse(e.content);
          if (data.DeviceId) {
            this.deviceID = data.DeviceId;
            this.enterManually(this.deviceID);
          }
        }
      });
    });
  }
  stopScan() {
    this.show = true;
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
    document.body.style.removeProperty('background-color');
  }


  onFlashlight() {
    BarcodeScanner.enableTorch();
    this.isTorch = true;

  }
  offFlashlight() {
    this.isTorch = false;
    BarcodeScanner.disableTorch();
  }


  enterManually(deviceId?) {
    let modalId = Date.now();
    let header = deviceId ? "device-field-add.confirm-id" : "device-field-add.enter-id-manually";
    let button = deviceId ? "device-field-add.confirm" : "device-field-add.save";
    this.modalService.presentModal({
      component: EnterConfirmIdComponent,
      id: modalId,
      componentProps: {
        header: header,
        deviceID: deviceId,
        button: button,
        type: this.isFilizMode ? "filiz" : "trap"
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      this.modalService.modalOnDidDismiss(modalId).then(e => {
        if (e.data) {
          this.deviceID = e.data;
          let payload: IFarmSaveModel = {
            CalculatedArea: this.farm.CalculatedArea,
            CropId: this.farm.CropId,
            CropVarietyId: this.farm.CropVarietyId,
            FarmName: this.farm.FarmName,
            GeoJson: this.farm.Location,
            HarvestDate: this.farm.HarvestDate ? this.farm.HarvestDate : "1970-01-01",
            SowingDate: this.farm.SowingDate ? this.farm.SowingDate : "1970-01-01",
            TempFarmAttId: this.farm.TempFarmAttId,
            IrrigationTypeId: this.farm.IrrigationTypeId,
            SensorId: this.deviceID,
            SoilTypeId: this.farm.SoilTypeId,
            FarmingMethodId: this.farm.FarmingMethodId,
            PhId: 44,
            ChillingEndDate: this.farm.ChillingEndDate,
            ChillingStartDate: this.farm.ChillingStartDate
          }
          let type = this.isFilizMode ? 'filiz' : 'trap';
          this.loadingService.showLoading();
          this.farmApi.FarmSave(payload, type).subscribe(farmResponse => {
            this.loadingService.hideLoading();
            if (farmResponse && farmResponse.IsSuccess) {
              // this.modalService.dismissByModalId(this.id, null, "success");
              this.storageService.lastFilizFarmId = null;
              this.storageService.lastTrapFarmId = null;
              this.storageService.set(StorageKeys.updated, true).then();
              this.router.navigate(["/common/detail"], {
                queryParams: {
                  sensorType: this.activatedRoute.snapshot.queryParams.sensorType,
                  farmId: this.farm.TempFarmAttId
                },
                replaceUrl: true
              });
            }
            this.loadingService.hideLoading();
          }, err => {
            this.loadingService.hideLoading()
            //TODO error durumunda ne olacak?
          }, () => {
            this.loadingService.hideLoading()
          })
        }
      });
    });
  }

}
